// umlaut-check: skip — "LkwBalken" ist ein Komponenten-/Dateiname
// (technischer Bezeichner), bleibt ASCII.

import React from "react";
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import {formatFaktor, formatKw, formatMenge, formatProzent} from "./format.js";
import {TOOLTIP_POPPER_CONFIG} from "./tooltipConfig.js";

/**
 * LKW-Auslastung einer Ankunftswoche (PLAN.md Abschnitt 4.7, Minute 33:
 * "Cosmos liefert nur volle LKW") - bereits geplante Lieferpositionen plus
 * offene Bestellvorschläge gegen die LKW-Kapazität. Über 100 % bedeutet
 * mehr als ein LKW in dieser Woche - kein Fehlerzustand, aber ein bewusster
 * Warnhinweis (Sichtprüfung 1, Befund 13: bis dahin erschien auch eine
 * Überladung grün wie ein voller, unproblematischer LKW).
 */
export default function LkwBalken({woche, onAuffuellen, canOrder}) {
    if (!woche) {
        return null;
    }

    const prozent = Number(woche.prozent) || 0;
    const ueberKapazitaet = woche.ueber_kapazitaet ?? prozent > 100;
    const breite = Math.min(100, Math.max(0, prozent));
    const voll = Boolean(woche.voll);
    const balkenFarbe = ueberKapazitaet ? "bg-danger" : voll ? "bg-success" : "bg-success bg-opacity-50";

    const hilfe = (
        <>
            Geplant: {formatMenge(woche.geplante_menge)} Dosen · Offene Vorschläge: {formatMenge(woche.offene_vorschlagsmenge)} Dosen · Kapazität:{" "}
            {formatMenge(woche.kapazitaet)} Dosen.
            {ueberKapazitaet && " Mehr als ein LKW in dieser Woche."}
        </>
    );

    return (
        <div className="d-flex align-items-center gap-2 mb-1" style={{minWidth: 260}}>
            <span className="small text-muted" style={{minWidth: 70}}>
                {formatKw(woche.kw)}
            </span>
            <OverlayTrigger flip popperConfig={TOOLTIP_POPPER_CONFIG} placement="top" overlay={<Tooltip id={`cosmos-lkw-${woche.kw}`}>{hilfe}</Tooltip>}>
                <div className="flex-grow-1" role="img" aria-label={`LKW-Auslastung ${formatKw(woche.kw)}: ${formatProzent(prozent)}${ueberKapazitaet ? ", überladen" : ""}`}>
                    <div className="progress" style={{height: 14}}>
                        <div className={`progress-bar ${balkenFarbe}`} style={{width: `${breite}%`}} />
                    </div>
                </div>
            </OverlayTrigger>
            <span className={`small text-nowrap ${ueberKapazitaet ? "text-danger fw-semibold" : ""}`} style={{minWidth: 96}}>
                {ueberKapazitaet ? `überladen: ${formatProzent(prozent)}` : formatProzent(prozent)}
            </span>
            {!voll && (
                <span className="small text-muted text-nowrap">
                    Rest {formatMenge(woche.rest_dosen)} ({formatFaktor(woche.rest_paletten, 1)} Pal.)
                </span>
            )}
            {!voll && onAuffuellen && canOrder && (
                <OverlayTrigger flip popperConfig={TOOLTIP_POPPER_CONFIG} placement="top" overlay={<Tooltip id={`cosmos-auffuellen-${woche.kw}`}>Schlägt vor, mit welchen Farbtönen sich dieser LKW sinnvoll auffüllen ließe – bestellt dabei nichts.</Tooltip>}>
                    <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => onAuffuellen(woche.kw)}>
                        Auffüllen vorschlagen
                    </button>
                </OverlayTrigger>
            )}
        </div>
    );
}
